<template>
<div>
    <el-dialog title="" :visible.sync="dialogEchartVisible" class="echart-dialog" :before-close='this.echartCancle' top="5vh" width='80%'>
            <div class="echart-content bm bm-ver">
                <div  v-loading="eloading">
                    <div class="switch-box bm bm-ac bm-pj">
                        <div class="bm bm-ver">
                            <h1>{{this.materialName}}</h1>
                            <h2 v-if="provinceName">{{this.provinceName}}</h2>
                        </div>
                        <div class="bm bm-pj bm-ac">
                            <div class="item-select bm bm-ac bm-pc" :class="[dateType=='quarter'||dateType=='month'?'':'hide']">
                                <i class="el-icon-caret-left" @click="dateTimeChange(-1)"></i>
                                <div class="item-val">{{dateTime}}</div>
                                <i class="el-icon-caret-right" @click="dateTimeChange(1)"></i>
                            </div>
                            <el-radio-group v-model="dateType" class="switch-icon bm bm-pe" @change="reSetOption">
                                <el-radio-button label="year">年</el-radio-button>
                                <el-radio-button label="quarter">季</el-radio-button>
                                <el-radio-button label="month">月</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="echart_box"  id="echart_lssjfx" :class="[!isEmpty?'':'hide']" ></div>
                    <div class="echart_box bm bm-ac bm-pc" v-if="isEmpty" >
                        <div class="no_data">暂无数据</div>
                    </div>
                </div>
                <div class="page-content">
                    <h2>销量预测</h2>
                    <el-table
                        :data="editFieldDataEchart"
                        align="center"
                        style="width: 100%"
                        slot="empty"
                        :cell-class-name="tableCellClassName"
                        :key="echartTableKey"
                        border
                        v-loading="loading"
                        element-loading-text="拼命加载中"
						:row-style="rowStyle"
                        :header-cell-style="{color: '#323232','font-size': '14px','background-color': '#f8f8f8',height: '50px','border-right': '1px solid #ebeef5'}">
                        <digital-column
                            v-for="(item, index) in editFieldHeadEchart"
                            :key="index"
                            :col="item"
                            :tableData="editFieldDataEchart" 
                            :editField="editFieldEchart" 
                            @modification="modification"
                            :width="item.width" >
                        </digital-column>
                    </el-table>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="echartCancle">取 消</el-button>
                <el-button type="primary" @click="echartConfirm">保 存</el-button>
            </div>
    </el-dialog> 
</div>  
</template>
<script> 
    // import echarts from 'echarts';
    import { salesApi } from "@/services";
    export default {
        name: "echarts",
        data() {
            return {
                eloading:true,
                isEmpty:false,//空数据就不能保存
                loading: false,//表格加载动画,默认false
                dateType:'month',
                echartTableKey:0,
                dateTime:new Date().getFullYear(),
                nowDate:new Date().getFullYear(),
                option_lssj:{
                    tooltip: {//选中的样式
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: 'red'//线标的颜色
                            }
                        }
                    },
                    legend: {//表头
                        data:['销量','增长率'],//标题头
                        bottom:'85%'
                    },
                    grid:{//图表样式
                        width:"92%",
                        left:"4%",
                        height:"70%"
                    },
                    xAxis: [//横坐标
                        {
                            type: 'category',
                            data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [//纵坐标
                        {
                            type: 'value',
                            name: '销量/1000',
                            nameTextStyle:{
                                color:'#323232',
                            },
                            min: 0,//最小值
                            max: 2000,//最大值
                            interval: 400,//递增值
                            axisLabel: {
                                formatter: '{value}'
                            }
                        },
                        {
                            type: 'value',
                            name: '增长率',
                            nameTextStyle:{
                                color:'#323232',
                            },
                            min: 0,//最小值
                            max: 100,//最大值
                            interval: 20,//递增值
                            axisLabel: {
                                formatter: '{value} %'
                            }
                        }
                    ],
                    series: [//表单值
                        {
                            name:'销量',
                            type:'bar',
                            data:[],
                            itemStyle:{
                                color:'#9fceff'
                            }
                        },
                        {
                            name:'增长率',
                            type:'line',
                            yAxisIndex: 1,//多曲线下的展示层级关系
                            data:[],
                            itemStyle:{
                                color:'#30af84'
                            }
                        }
                    ]
                },
                incomePara:{},
                hiddenField:[],
                titleSort:[]
            }
        },
        watch: {
            dialogEchartVisible:{
                handler(newName, oldName) {
                    if(newName==true){
                        this.dateTime = new Date().getFullYear()
                        this.nowDate = new Date().getFullYear()
                        this.dateType = 'month'
                        this.isEmpty = false
                        this.getEchartsData()
                        this.echartTableKey++
                    }
            　　    
            　　}
            }
        },
        props:{
            editFieldEchart:{//可编辑的选项
                type: Array
            },
            editFieldHeadEchart:{//可编辑的选项头部
                type: Array
            },
            editFieldDataEchart:{//可编辑的选项具体值
                type: Array
            },
            dialogEchartVisible:{//是否展示插件
                type: Boolean
            },
            echartType:{//接口类型
                type:String
            },
            materialCode:{//产品编码
                type:String
            },
            materialName:{
                type:String
            },
            provinceCode:{//省份编码	
                type:String
            },
            provinceName:{//省份名称	
                type:String
            },
        },
        
        methods: {
            //给需要编辑的列添加背景颜色
            tableCellClassName({row, column, rowIndex, columnIndex}) {
                column.index = columnIndex
                let classname = "";
                if(this.editFieldEchart.indexOf(column.property) != -1) {
                    if (row[column.property] && row[column.property].length == 0){
                        classname += " placeholder-color";
                    }else {
                        classname += " normal-color";
                    }
                    classname += " edit";
                    return classname;
                }
            },
			rowStyle({ row, rowIndex}) {
				return 'height:38px';
			},
            echartConfirm(){
                this.$emit('echartConfirm','');
            },
            echartCancle(){
                this.$emit('echartCancle');
            },
            reSetOption() {
                this.getEchartsData();
            },
            dateTimeChange(value){
                if( (value>0&&(this.dateTime!=this.nowDate)) || (value<0&&((this.nowDate-this.dateTime<5))) ){
                    this.dateTime = this.dateTime + value ;
                    this.getEchartsData();
                }
            },
            setEchart(){
                let lssjChart ;
                if( document.getElementById('echart_lssjfx')){
                    lssjChart = echarts.init(document.getElementById('echart_lssjfx'));
                    lssjChart.setOption(this.option_lssj);
                    //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
                    window.addEventListener('resize',function() {lssjChart.resize()});
                }
            },
            setNullData(){
                
                
            },
            //查询列表
            getEchartsData(){
                console.log(this.provinceName)
                let _this = this,
                    xAxisScale = '月';
                _this.dateType=='quarter'?xAxisScale = '季':xAxisScale = '月';
                //清空数值
                _this.option_lssj.xAxis[0].data=[];
                _this.option_lssj.series[0].data=[];
                _this.option_lssj.series[1].data=[];
                if(_this.echartType == "marketIncome"){
                    _this.incomePara = {
                        "configurationId":this.$store.state.init.initData.configurationId,
                        "materialCode":this.materialCode,
                        "dimension":this.dateType,
                        "year":this.dateTime.toString()
                    };
                    _this.eloading = true;
                    salesApi.getMarketIncomeHistory(_this.incomePara).then(res => {
                        if (res && res.msgCode == '100' ) {
                            _this.eloading = false;
                            if (res.responseData) {//有数据
                                if(res.responseData.list){
                                    this.option_lssj.yAxis[0].min = Math.round(res.responseData.salesVolumeMin)
                                    this.option_lssj.yAxis[0].max = Math.round(res.responseData.salesVolumeMax)
                                    this.option_lssj.yAxis[0].interval = Math.round((res.responseData.salesVolumeMax-res.responseData.salesVolumeMin)/6);
                                    this.option_lssj.yAxis[1].min = Math.round(res.responseData.salesVolumeRateMin*100)
                                    this.option_lssj.yAxis[1].max = Math.round(res.responseData.salesVolumeRateMax*100)
                                    this.option_lssj.yAxis[1].interval = Math.round((res.responseData.salesVolumeRateMax-res.responseData.salesVolumeRateMin)*100/6);
                                    res.responseData.list.forEach(elm => {
                                        if(this.dateType=='year'){
                                            _this.option_lssj.xAxis[0].data.push(elm.year+'年');
                                        }else{
                                            _this.option_lssj.xAxis[0].data.push(elm.value+xAxisScale);
                                        }
                                        _this.option_lssj.series[0].data.push(elm.salesVolume);
                                        _this.option_lssj.series[1].data.push(elm.salesVolumeRate*100);
                                    });
                                    _this.setEchart();
                                    this.isEmpty = false;
                                }else{
                                    this.isEmpty = true;
                                }
                                
                            }
                        }
                    });
                }else if(_this.echartType == "pureSale"){
                    _this.incomePara = {
                        "configurationId":this.$store.state.init.initData.configurationId,
						"materialCode":this.materialCode,
						"provinceCode":this.provinceCode,
                        "dimension":this.dateType,
                        "year":this.dateTime
                    };
                    _this.eloading = true;
                    salesApi.getPureHistory(_this.incomePara).then(res => {
                        _this.eloading = false;
                        if (res && res.msgCode == '100' ) {
                            _this.eloading = false;
							if (res.responseData) {//有数据
								if( res.responseData.list ){
                                    this.option_lssj.yAxis[0].min = Math.round(res.responseData.salesVolumeMin)
                                    this.option_lssj.yAxis[0].max = Math.round(res.responseData.salesVolumeMax)
                                    this.option_lssj.yAxis[0].interval = Math.round((res.responseData.salesVolumeMax-res.responseData.salesVolumeMin)/6);
                                    this.option_lssj.yAxis[1].min = Math.round(res.responseData.salesVolumeRateMin*100)
                                    this.option_lssj.yAxis[1].max = Math.round(res.responseData.salesVolumeRateMax*100)
                                    this.option_lssj.yAxis[1].interval = Math.round((res.responseData.salesVolumeRateMax-res.responseData.salesVolumeRateMin)*100/6);
									res.responseData.list.forEach(elm => {
										if(this.dateType=='year'){
											_this.option_lssj.xAxis[0].data.push(elm.year+'年');
										}else{
											_this.option_lssj.xAxis[0].data.push(elm.value+xAxisScale);
										}
										_this.option_lssj.series[0].data.push(elm.salesVolume);
										_this.option_lssj.series[1].data.push(elm.salesVolumeRate*100);
                                    });
                                    _this.setEchart();
                                    this.isEmpty = false;
								}else{
                                    this.isEmpty = true;
                                }
                            }
                        }
                    });
                }else if(_this.echartType == "channel"){
                    _this.incomePara = {
                        "configurationId":this.$store.state.init.initData.configurationId,
						"materialCode":this.materialCode,
						"provinceCode":this.provinceCode,
                        "dimension":this.dateType,
                        "year":this.dateTime
                    };
                    _this.eloading = true;
                    salesApi.getChannelHistory(_this.incomePara).then(res => {
                        _this.eloading = false;
                        if (res && res.msgCode == '100' ) {
							if (res.responseData) {//有数据
								if( res.responseData.list ){
                                    this.option_lssj.yAxis[0].min = Math.round(res.responseData.salesVolumeMin)
                                    this.option_lssj.yAxis[0].max = Math.round(res.responseData.salesVolumeMax)
                                    this.option_lssj.yAxis[0].interval = Math.round((res.responseData.salesVolumeMax-res.responseData.salesVolumeMin)/6);
                                    this.option_lssj.yAxis[1].min = Math.round(res.responseData.salesVolumeRateMin*100)
                                    this.option_lssj.yAxis[1].max = Math.round(res.responseData.salesVolumeRateMax*100)
                                    this.option_lssj.yAxis[1].interval = Math.round((res.responseData.salesVolumeRateMax-res.responseData.salesVolumeRateMin)*100/6);
									res.responseData.list.forEach(elm => {
										if(this.dateType=='year'){
											_this.option_lssj.xAxis[0].data.push(elm.year+'年');
										}else{
											_this.option_lssj.xAxis[0].data.push(elm.value+xAxisScale);
										}
										_this.option_lssj.series[0].data.push(elm.salesVolume);
										_this.option_lssj.series[1].data.push(elm.salesVolumeRate*100);
                                    });
                                    _this.setEchart();
                                    this.isEmpty = false;
								}else{
                                    this.isEmpty = true;
                                }
                            }
                        }
                    });
                }else if(_this.echartType == "basic"){
                    _this.incomePara = {
						"configurationId": this.$store.state.init.initData.configurationId,
						"materialCode": this.materialCode,
						"provinceCode":this.provinceCode,
						"dimension": this.dateType,
						"year": this.dateTime
                    }
                    _this.eloading = true;
                    salesApi.getGrassRootHistory(_this.incomePara).then(res => {
                        if (res && res.msgCode == '100' ) {
                            _this.eloading = false;
							if (res.responseData) {//有数据
								if( res.responseData.list ){
                                    this.option_lssj.yAxis[0].min = Math.round(res.responseData.salesVolumeMin)
                                    this.option_lssj.yAxis[0].max = Math.round(res.responseData.salesVolumeMax)
                                    this.option_lssj.yAxis[0].interval = Math.round((res.responseData.salesVolumeMax-res.responseData.salesVolumeMin)/6);
                                    this.option_lssj.yAxis[1].min = Math.round(res.responseData.salesVolumeRateMin*100)
                                    this.option_lssj.yAxis[1].max = Math.round(res.responseData.salesVolumeRateMax*100)
                                    this.option_lssj.yAxis[1].interval = Math.round((res.responseData.salesVolumeRateMax-res.responseData.salesVolumeRateMin)*100/6);
									res.responseData.list.forEach(elm => {
										if(this.dateType=='year'){
											_this.option_lssj.xAxis[0].data.push(elm.year+'年');
										}else{
											_this.option_lssj.xAxis[0].data.push(elm.value+xAxisScale);
										}
										_this.option_lssj.series[0].data.push(elm.salesVolume);
										_this.option_lssj.series[1].data.push(elm.salesVolumeRate*100);
                                    });
                                    _this.setEchart();
                                    this.isEmpty = false;
								}else{
                                    this.isEmpty = true;
                                }
							}
						}
					});
				}
            },
            //input 监听 index下标 row 一行数据 prop 属性 val值 新数组tableData
            modification(e) {
                
                this.$emit("changeEcharts",e.tableData)
            },
		},
        mounted() {
        }
    }
</script>

<style lang="scss">
.echart-content{
    .page-content{
        padding: 0;
    }
    width: 100%;
    height: auto;
    margin: 0 auto;
    h2{
        font-size: 14px;
        color: #323232;
        padding: 0 0 3px 0;
        margin: 0;
    }
    .switch-box{
        height: 30px;
        margin-bottom: 0px;
        .item-select{
            margin-right: 53px;
            .item-val{
                color: #409eff;
                font-size: 18px;
                margin: 0 22px;
            }
        }
        .switch-icon{
            width: 200px;
            height: 28px;
            border-radius: 14px;
            border: solid 1px #409eff;
            .el-radio-button__inner{
                width: 64px;
                height: 24px;
                font-size: 16px;
                border: 0;
                border-radius: 13px;
                padding: 5px;
                margin:1px;
                color: #323232;
            }
            .el-radio-button__orig-radio:checked + .el-radio-button__inner{
                color: #fff;
                background-color: #409eff;
                border-color: #409eff;
                -webkit-box-shadow: -1px 0 0 0 #409eff;
                box-shadow: -1px 0 0 0 #409eff;
                border-radius: 13px;
            }
        }
        h1{
            font-size: 20px;
	        font-weight: bold;
            color: #323232;
            margin: 0 0 10px 0;
        }
        
        .item{
            width: 60px;
            margin-right: 15px;
            font-size: 20px;
            border: 1px solid #C2C2C2; 
            border-radius: 20px;
            background-color: #fff;
            color: #000;
            font-weight: bold;
        }
        .active{
            background-color: #BCD2EE;
            color: #fff;
        }
    }
    .echart_box{
        width: 100%;
        height: 310px;
        max-height: 310px;
        border: 0px solid #ABABAB;
        margin: 0 auto;

    }
    .no_data{
        font-size: 20px;
        color: #969696;
        letter-spacing: 8px;
    }
    .hide{
        display: none;
    }
    
}
</style>



